import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-delete-confirmation-dialog',
  templateUrl: './delete-confirmation-dialog.component.html',
  styleUrls: ['./delete-confirmation-dialog.component.scss']
})
export class DeleteConfirmationDialogComponent implements OnInit {

  dataType: any;
  dataName: any;
  firstStep: boolean = true;
  secondStep: boolean = false;
  clickToConfirm: boolean = false;
  clickToConfirmError: boolean =  false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>) {
      this.dataName = data.dataName;
      this.dataType = data.dataType;
  }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    console.log(this.clickToConfirm);
    if (this.clickToConfirm) {
      this.clickToConfirmError =  false;
      this.firstStep = false;
      this.secondStep = true;
    } else {
        this.clickToConfirmError = true;
    }
  }

  confirmDelete() {
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/delete-confirmation-dialog/delete-confirmation-dialog.component.ts